import styled from '@emotion/styled'

import CopyTextBase, * as CopyText from '@segment/matcha/recipes/CopyText'
import SectionBase, * as Section from '@segment/matcha/recipes/Section'

import FeatureBoxGroup from './components/FeatureBoxGroup'

const copy = {
  heading: `Segment’s commitment to data privacy`,
  description: `We take the responsibility of respecting privacy seriously. Here are a few initiatives Segment is committed to:`,
}

const SegmentCommitment = () => {
  return (
    <SectionBaseWrapper variant="centered">
      <Section.Copy>
        <CopyTextBaseWrapper centered={true}>
          <CopyText.Heading variant="h2" tag="h2">
            {copy.heading}
          </CopyText.Heading>
          <CopyText.Description variant="pLarge" tag="p">
            {copy.description}
          </CopyText.Description>
        </CopyTextBaseWrapper>
      </Section.Copy>
      <Section.Contents>
        <FeatureBoxGroup />
      </Section.Contents>
    </SectionBaseWrapper>
  )
}

const SectionBaseWrapper = styled(SectionBase)`
  ${Section.Wrapper} {
    row-gap: 0;
  }
`

const CopyTextBaseWrapper = styled(CopyTextBase)`
  text-align: left;
  padding-bottom: 20px;
  ${({ theme }) => theme.breakpoints.up(`md`)} {
    max-width: 844px;
    text-align: center;
    padding-bottom: 0;
  }
`

export default SegmentCommitment
